import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { EncashmentsStatusType, encashmentsStatusTitle } from 'app/dataTypes/reports/data'

export type EncashmentsStatusData = Array<ItemType>

class EncashmentsStatusFilterDataBox extends DataBox<EncashmentsStatusData> { }

export const defaultEncashmentsStatus: EncashmentsStatusData = []
export const encashmentsStatusFilter = createDataBox('encashmentsStatusFilter', defaultEncashmentsStatus, EncashmentsStatusFilterDataBox)


export const getEncashmentsStatusData = () => {
  return [
    { id: EncashmentsStatusType.CashAccepted, title: encashmentsStatusTitle[EncashmentsStatusType.CashAccepted] },
    { id: EncashmentsStatusType.CashRefused, title: encashmentsStatusTitle[EncashmentsStatusType.CashRefused] },
    { id: EncashmentsStatusType.WaitingForCash, title: encashmentsStatusTitle[EncashmentsStatusType.WaitingForCash] },
    { id: EncashmentsStatusType.CashNotDeposited, title: encashmentsStatusTitle[EncashmentsStatusType.CashNotDeposited] },
  ]
}

export const defaultEncashmentsStatusSelection: Array<string> = []
export const encashmentsStatusFilterSelection = createDataBoxDefault<Array<string>>('encashmentsStatusFilterSelection', defaultEncashmentsStatusSelection)
